enum BulkImportStatus {
  NEW = 'new',
  HEADERS_MAPPED = 'headers mapped',
  PRE_PROCESSING_DATA = 'pre-processing data',
  DATA_PRE_PROCESSED = 'data pre-processed',
  READY_TO_PROCESS = 'ready to process',
  PROCESSING_DATA = 'processing data',
  DATA_PROCESSED = 'data processed',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
  REVERT = 'revert',
  REVERTING = 'reverting',
  REVERTED = 'reverted',
}

export default BulkImportStatus;
